export class KEY {
    //test
    // static readonly KEY_GOOGLE_CAPTCHA = '6LcOZ3EUAAAAAEConeHYXqaVsRdhCItlIxi1FhmI';

    //release dang dùng capcha của anh ngọc
    static readonly KEY_GOOGLE_CAPTCHA = '6LcGZkIUAAAAABxKZrblv71ghoGVCVl23vkY84FH';
    //test
    static readonly APP_ID_TEST = 'MOBILE_HUTECH';
    //release
    static readonly APP_ID = 'ROYAL';
}